import { ethers } from 'ethers';
import { USDT_DECIMALS } from '../config/addresses';

// CSV value (e.g. "123.45") -> BigNumber scaled to 18 decimals
export function toUnits(value) {
  const clean = String(value).trim().replace(/,/g, '');
  if (clean === '' || isNaN(Number(clean))) return ethers.BigNumber.from(0);
  return ethers.utils.parseUnits(clean, USDT_DECIMALS);
}

// BigNumber (18 decimals) -> readable string
export function fromUnits(bn) {
  try {
    return ethers.utils.formatUnits(bn, USDT_DECIMALS);
  } catch (_) {
    return '0';
  }
}

// pretty money: 1234.5 -> "1,234.50"
export function money(bn, dp = 2) {
  const n = Number(fromUnits(bn));
  return n.toLocaleString('en-US', { minimumFractionDigits: dp, maximumFractionDigits: dp });
}

export function shortAddr(a) {
  if (!a) return '';
  return a.slice(0, 6) + '…' + a.slice(-4);
}

export function fmtDate(unixSeconds) {
  if (!unixSeconds) return '—';
  const d = new Date(Number(unixSeconds) * 1000);
  return d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
}

// current week id like 20260601 from today's date (admin can override)
export function defaultWeekId() {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return Number(`${y}${m}${day}`);
}

// unix seconds for the start of the current week (Monday 00:00 local)
export function weekStartTs() {
  const d = new Date();
  const day = (d.getDay() + 6) % 7; // 0 = Monday
  d.setHours(0, 0, 0, 0);
  d.setDate(d.getDate() - day);
  return Math.floor(d.getTime() / 1000);
}

// yyyymmdd of the current week's Monday — stable for the whole week,
// used as the snapshot key so "this week" rolls over once per week.
export function weekIdMonday() {
  const d = new Date(weekStartTs() * 1000);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return Number(`${y}${m}${day}`);
}
